import * as S from "./EquipCurrentStatus.style";

interface EquipCurrentStatusProps {
  time?: any;
  powerOn?: boolean;
  statNormal?: string;
  stateName?: string;
}

export const EquipCurrentStatus = ({
  time,
  powerOn,
  statNormal,
  stateName,
}: EquipCurrentStatusProps) => {
  return (
    <S.EquipCurrentStatus>
      <S.EquipCurrentTime>
        <span>{powerOn ? "운전시간" : "정지시간"}</span>
        {time}
      </S.EquipCurrentTime>

      <S.EquipCurrentPower powerOn={powerOn}>
        {powerOn ? "on" : "off"}
      </S.EquipCurrentPower>

      <S.EquipCurrentStat statNormal={statNormal}>
        {stateName}
      </S.EquipCurrentStat>
    </S.EquipCurrentStatus>
  );
};
